import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AIONZ_DIALOG_DATA, AionzDialogModule, AionzDialogRef, EmptyContentComponent, HeaderBottomSheetComponent } from '@aionzdev/design-system';
import { OrderHistoryTooltipData } from '../../../interfaces/order-history-tooltip-data';
import { OrderHistoryAccordionComponent } from '../../atoms/order-history-accordion/order-history-accordion.component';

@Component({
  selector: 'aionz-order-history-dialog',
  imports: [AionzDialogModule, HeaderBottomSheetComponent, OrderHistoryAccordionComponent, EmptyContentComponent],
  templateUrl: './order-history-dialog.component.html',
  styleUrl: './order-history-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderHistoryDialogComponent {
  protected readonly data = inject(AIONZ_DIALOG_DATA) as OrderHistoryTooltipData;
  protected readonly _refDialog = inject(AionzDialogRef<OrderHistoryDialogComponent>);
  public displayItems = this.data.items ?? [];

  close(): void {
    this._refDialog.close();
  }
}
